import { GetServerSideProps } from 'next';

import Head from '@wetransfer/transfer-new/components/Head';
import ClientSideApp from '@wetransfer/transfer/ClientSideApplication';
import fetchInitialData from '@wetransfer/transfer/helper/fetchInitialData';
import setLocaleFromRequest from '@wetransfer/transfer/helper/setLocaleFromRequest';

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  setLocaleFromRequest(req);

  const data = await fetchInitialData(req);

  if (data?.redirect) {
    return {
      redirect: {
        ...data.redirect,
      },
    };
  }

  return {
    props: {
      data,
    },
  };
};

const Home = (props: any) => (
  <>
    <Head />
    <ClientSideApp data={props.data} />
  </>
);

export default Home;
